import { render, staticRenderFns } from "./AtomIconBook.vue?vue&type=template&id=70b1a785&functional=true&"
import script from "./AtomIconBook.vue?vue&type=script&lang=ts&"
export * from "./AtomIconBook.vue?vue&type=script&lang=ts&"
import style0 from "./AtomIconBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports